import React from 'react';

const TabButton = ({ active, onClick, children, count, className = '' }) => (
  <button
    onClick={onClick}
    className={`
      relative px-4 py-2 text-sm font-medium transition-all duration-200
      ${active 
        ? 'text-neutral-900 bg-white shadow-md' 
        : 'text-neutral-600 hover:text-neutral-800 hover:bg-white/50'
      }
      rounded-xl border
      ${active 
        ? 'border-neutral-900 shadow-sm' 
        : 'border-transparent hover:border-neutral-300'
      }
      ${className}
    `}
  >
    <span className="relative z-10 flex items-center gap-2">
      {children}
      {count !== undefined && (
        <span className={`
          px-2 py-0.5 text-xs rounded-full
          ${active 
            ? 'bg-butter-500 text-neutral-900' 
            : 'bg-neutral-200 text-neutral-600'
          }
        `}>
          {count}
        </span>
      )}
    </span>
  </button>
);

export default TabButton; 